import { render } from "./ZutatenHinzufuegenView.vue?vue&type=template&id=26764aac&scoped=true"
import script from "./ZutatenHinzufuegenView.vue?vue&type=script&lang=js"
export * from "./ZutatenHinzufuegenView.vue?vue&type=script&lang=js"

import "./ZutatenHinzufuegenView.vue?vue&type=style&index=0&id=26764aac&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-26764aac"]])

export default __exports__